const normalizeEmail = (email) => (typeof email === 'string' ? email.trim().toLowerCase() : '')

/** Emails that appear more than once in the invitee list (case-insensitive). */
export const buildDuplicateEmailSet = (invitees = []) => {
  const counts = new Map()

  invitees.forEach((invitee) => {
    const key = normalizeEmail(invitee?.email)
    if (!key) return
    counts.set(key, (counts.get(key) ?? 0) + 1)
  })

  const duplicates = new Set()
  counts.forEach((count, email) => {
    if (count > 1) duplicates.add(email)
  })

  return duplicates
}

/** Prefer signup name when this invitee shares an email with another row. */
export const resolveAttendeeNameSource = (invitee, duplicateEmails) => {
  const key = normalizeEmail(invitee?.email)
  if (key && duplicateEmails?.has(key)) return 'signup'
  return 'contact'
}
